<!--  -->
<template>
  <div>
    <!-- <el-button
      @click="addTree"
      style="margin-bottom: 10px;"
      icon="el-icon-plus"
      type="warning"
    >新增</el-button>
    <div class="wahw_box">
      <div
        v-for="(itemqw,index) in allarr"
        :key="index"
        class="dkwerq"
      >
        <div class="rulewr_box">
          <div class="tryewe">来源小程序：</div>
          <el-tag
            v-for="item,indexr in itemqw.staffarr"
            :key="indexr"
            style="margin-right: 10px;margin-bottom: 5px;"
            closable
            @close="closestaff(indexr,index)"
          >{{ item.name }}</el-tag>
          <div><el-button
              type="primary"
              size="mini"
              @click="choosestaff(index)"
            >选择来源小程序</el-button></div>
        </div>
        <div
          class="rulewr_box"
          v-if="itemqw.staffarr.length!=0"
        >
          <div class="tryewe">小程序来源分类：</div>
          <el-tree
            :data="itemqw.data"
            show-checkbox
            default-expand-all
            node-key="id"
            highlight-current
            :props="defaultProps"
            :ref="`tree-${index}`"
            :default-checked-keys="itemqw.applet_category"
            @check="updateCheckedKeys(index, $event)"
          />
        </div>
        <div class="rulewr_box">
          <div class="tryewe">小程序目标分类：</div>
          <el-tag
            v-if="itemqw.target_category!=''"
            style="margin-right: 10px;"
          >{{ itemqw.target_name }}</el-tag>
          <el-button
            type="primary"
            size="mini"
            @click="choosefenlei(index)"
          >选择目标分类
          </el-button>
        </div>
        <el-button
          v-if="allarr.length>1"
          style="margin-left: 20px;margin-bottom: 10px;"
          icon="el-icon-delete"
          type="danger"
          @click="deltert(index)"
        >删除</el-button>
      </div>
    </div> -->
    <div class="rulewr_box">
      <div class="tryewe">小程序目标分类：</div>
      <el-tag
        v-for="item,indexr in fenleiarr"
        :key="indexr"
        style="margin-right: 10px"
        closable
        @close="newclosefenlei(indexr)"
        type="success"
      >{{ item.name }}</el-tag>
      <el-button
        type="primary"
        size="mini"
        @click="newchoosefenlei"
      >选择目标分类
      </el-button>
    </div>
    <div
      class="rulewr_box"
      style="margin-top: 10px;"
      v-if="type === 1"
    >
      <div class="tryewe">目标小程序：</div>
      <el-tag
        v-for="item,indexrw in wechatarr"
        :key="indexrw"
        style="margin-right: 10px;margin-bottom: 5px;"
        closable
        @close="closewechat(indexrw)"
      >{{ item.account_name }}</el-tag>
      <div><el-button
          type="primary"
          size="mini"
          @click="choosewechat"
        >选择小程序</el-button></div>
    </div>
    <div
      class="rulewr_box"
      style="margin-top: 10px;"
      v-if="type === 2"
    >
      <div class="tryewe">目标小程序：</div>
      <el-tag
        v-if="editapp_id!=''"
        style="margin-right: 10px;margin-bottom: 5px;"
      >{{ editapp_name }}</el-tag>
    </div>
    <el-button
      type="primary"
      @click="sumbit"
    >提交</el-button>
    <el-dialog
      title="选择来源小程序"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :append-to-body="true"
      :visible.sync="staffdialogVisibler"
      :destroy-on-close="true"
      width="50%"
    >
      <staffband
        ref="staffbandview"
        @bandarr="bandarr"
      />
    </el-dialog>
    <el-dialog
      title="选择小程序分类"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :append-to-body="true"
      :visible.sync="staffWecahrdialog"
      :destroy-on-close="true"
      width="50%"
    >
      <comestaffband
        ref="comestaffbandview"
        @lybandarr="lybandarr"
      />
    </el-dialog>
    <el-dialog
      title="目标分类"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :append-to-body="true"
      :visible.sync="targetclassificationdialog"
      :destroy-on-close="true"
      width="50%"
    >
      <targetclassification
        ref="targetclassificationview"
        @targetclass="targetclass"
      />
    </el-dialog>
    <el-dialog
      title="目标分类"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :append-to-body="true"
      :visible.sync="fenleidialog"
      :destroy-on-close="true"
      width="50%"
    >
      <fenleiband
        ref="fenleibandview"
        @bandcallabckarr="bandcallabckarr"
      />
    </el-dialog>
  </div>
</template>

<script>
import staffband from './staffband.vue'
import comestaffband from './comestaffband.vue'
import targetclassification from './targetclassification.vue'
import { videoSettingcategoryList, videoCategoryRelationstore, videoCategoryRelationdetail, videoCategoryRelationupdate } from '@/api/sourceminiprogram.js'
import fenleiband from './fenleiband.vue'
export default {
  components: { staffband, comestaffband, targetclassification, fenleiband },
  data() {
    return {
      allarr: [
        {
          staffarr: [],
          data: [],
          applet_category: [],
          target_category: '',
          target_name: '',
          applet_nos: []
        }
      ],
      labelPosition: 'right',
      staffdialogVisibler: false,
      wechatarr: [],
      staffWecahrdialog: false,
      targetclassificationdialog: false,
      type: null,
      fifterarr: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      zongindex: null,
      selectedValues: [],
      app_ids: [],
      newArray: [],
      editapp_id: '',
      editapp_name: '',
      fenleidialog: false,
      fenleiarr: [],
      chuanfenleiarr: []
    }
  },
  created() {},
  mounted() {},
  methods: {
    send(type, item) {
      this.type = type
      if (this.type === 2) {
        console.log('item', item)
        videoCategoryRelationdetail({
          app_id: item.app_id
        }).then(res => {
          console.log('res', res.data)
          // this.allarr = []
          // this.allarr = res.data.map(item => ({
          //   data: item.source_category,
          //   applet_category: item.applet_category,
          //   target_category: item.target_category,
          //   target_name: item.target_category_name,
          //   staffarr: item.external_applet_name,
          //   applet_nos: []
          // }))
          this.fenleiarr = res.data.category_info
          this.editapp_id = res.data.app_id
          this.editapp_name = res.data.applet_name
          console.log('res', this.allarr)
        })
      }
    },
    closestaff(indexr, index) {
      this.zongindex = index
      this.allarr[index].staffarr.splice(indexr, 1)
      this.gettree()
    },
    closewechat(indexrw) {
      this.wechatarr.splice(indexrw, 1)
    },
    choosestaff(index) {
      this.zongindex = index
      this.staffdialogVisibler = true
      console.log('this.allarr[index].staffarr', this.allarr[index].staffarr)
      this.$nextTick(() => {
        this.$refs.staffbandview.sendr(this.allarr[index].staffarr)
      })
    },
    choosewechat() {
      console.log('fifterarr', this.fifterarr)
      this.staffWecahrdialog = true
      this.$nextTick(() => {
        this.$refs.comestaffbandview.sendr(this.wechatarr)
      })
    },
    bandarr(arr) {
      this.staffdialogVisibler = false
      this.allarr[this.zongindex].staffarr = []
      this.allarr[this.zongindex].staffarr = arr
      this.gettree()
    },
    lybandarr(arr) {
      this.staffWecahrdialog = false
      this.wechatarr = []
      this.wechatarr = arr
    },
    async gettree() {
      this.fifterarr = []
      this.fifterarr = this.allarr[this.zongindex].staffarr.map((itemr, indexrs) => {
        return itemr.app_no
      })
      if (this.allarr[this.zongindex].staffarr.length != 0) {
        const data = await videoSettingcategoryList({ applet_nos: this.fifterarr })
        console.log('data', data.data)
        this.allarr[this.zongindex].data = data.data
      }
    },
    addTree() {
      this.allarr.push({
        staffarr: [],
        data: [],
        applet_category: [],
        target_category: '',
        target_name: '',
        applet_nos: []
      })
    },
    choosefenlei(index) {
      this.zongindex = index
      this.targetclassificationdialog = true
      this.$nextTick(() => {
        this.$refs.targetclassificationview.send()
      })
    },
    targetclass(item) {
      // this.targetclassificationdialog = false
      const indexr = this.allarr.findIndex(items => {
        return items.target_category == item.id
      })
      if (indexr == -1) {
        this.targetclassificationdialog = false
        this.allarr[this.zongindex].target_category = item.id
        this.allarr[this.zongindex].target_name = item.name
      } else {
        // this.allarr[this.zongindex].applet_category.splice(indexr, 1)
        this.$message.error('请勿选择重复的分类')
      }
    },
    updateCheckedKeys(index, applet_category) {
      // console.log('applet_category', applet_category, index)
      this.zongindex = index
      // const indexr = this.allarr[this.zongindex].applet_category.findIndex(items => {
      //   return items == applet_category.id
      // })
      // if (indexr == -1) {
      //   this.allarr[this.zongindex].applet_category.push(applet_category.id)
      // } else {
      //   this.allarr[this.zongindex].applet_category.splice(indexr, 1)
      // }
      // this.$refs.tree.getCheckedKeys(true)
    },
    getSelectedValues() {
      this.selectedValues = this.allarr
        .flatMap(item => item.applet_category) // 获取每个树的选中键
        .filter(key => this.isChildNode(key)) // 过滤出子节点 ID
    },
    isChildNode(key) {
      // 检查选中的 ID 是否为子节点
      return this.treeData.some(tree => tree.children && tree.children.some(child => child.id === key))
    },
    sumbit() {
      // // 旧
      // // 获取每棵树的选中值
      // this.allarr.forEach((item, index) => {
      //   const treeRef = this.$refs[`tree-${index}`][0] // 获取对应树的引用
      //   item.applet_category = treeRef.getCheckedKeys(true) // 更新选中值
      //   item.applet_nos = item.staffarr.map(itemr => {
      //     return itemr.app_no
      //   })
      // })
      // this.newArray = []
      // this.newArray = this.allarr.map(item => ({
      //   applet_nos: item.applet_nos,
      //   applet_category: item.applet_category,
      //   target_category: item.target_category
      // }))

      if (this.fenleiarr.length === 0) {
        this.$message({
          message: '请选择目标分类',
          type: 'error'
        })
        return
      }
      if (this.type === 1) {
        if (this.wechatarr.length === 0) {
          this.$message({
            message: '请选择目标小程序',
            type: 'error'
          })
          return
        }
      }
      this.chuanfenleiarr = []
      this.chuanfenleiarr = this.fenleiarr.map(item => {
        // item是数组中的每一个值
        return item.id
      })
      this.app_ids = []
      this.app_ids = this.wechatarr.map(itemwr => {
        return itemwr.app_id
      })
      if (this.type === 1) {
        videoCategoryRelationstore({
          // relation: this.newArray,
          target_category: this.chuanfenleiarr,
          app_ids: this.app_ids
        }).then(res => {
          console.log('res', res)
          this.$message({
            message: '新建成功',
            type: 'success'
          })
          console.log('this.allarr', this.allarr, this.newArray)
          this.$emit('updata')
        })
      } else {
        videoCategoryRelationupdate({
          // relation: this.newArray,
          target_category: this.chuanfenleiarr,
          app_id: this.editapp_id
        }).then(res => {
          console.log('res', res)
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          console.log('this.allarr', this.allarr, this.newArray)
          this.$emit('updata')
        })
      }
    },
    deltert(index) {
      console.log('index', index)
      this.allarr.splice(index, 1)
    },
    newchoosefenlei() {
      this.fenleidialog = true
      this.$nextTick(() => {
        this.$refs.fenleibandview.sendr(this.fenleiarr)
      })
    },
    bandcallabckarr(arr) {
      this.fenleidialog = false
      this.fenleiarr = []
      this.fenleiarr = arr
    },
    newclosefenlei(index) {
      this.fenleiarr.splice(index, 1)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.aiwerw {
  display: flex;
  align-items: center;
}
.dwwerwart {
  display: flex;
}
.rulewr_box {
  display: flex;
  align-items: center;
  margin-bottom: 31px;
  flex-wrap: wrap;
}
.dkwerq {
  border: 1px solid #409eff;
  /* padding: 20px 0px; */
  padding-top: 20px;
  border-radius: 10px;
  margin-bottom: 20px;
}
.tryewe {
  /* width: 124px; */
  width: 125px;
  flex-shrink: 0;
  text-align: right;
  color: rgb(169, 162, 151);
  font-size: 14px;
}
.wahw_box {
  max-height: 600px;
  overflow-y: auto;
}
</style>
